<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="6"
		/>
		<p>نتیجه ارزیابی</p>
		<p>{{ val.value.comment }}</p>
		<btn 
		type="secondary" 
		style="margin-top: 33px;"
		text="نقص مدارک / ویرایش" 
		@clickMe="setPage();"
		/>
		<textareaInput
		label="توضیحات"
		:value= "val.value.comment"
		:disabled="true"
		class="mb-3"
		/>
	</div>
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
	import textareaInput from "../../UI/input/textareaInput.vue";
	

	export default {
		name: 'wait_signup',
		data(){
			return {
			}
		},
		components: {
			btn,
			multi_step_progress,
			textareaInput,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
			setPage(THIS = this){
				if(this.$localStorage.get('user')) {
					window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: 'status' ,val: 7, id: this.val.id, admin: this.$localStorage.get('user')}, function () {
						THIS.val.page=4;
						THIS.$emit('next_page', THIS.val);
					}, "json");
				} else {
					window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: 'status' ,val: 7, id: this.val.id}, function () {
						THIS.val.page=4;
						THIS.$emit('next_page', THIS.val);
					}, "json");
				}
				
			},
		}
	}
</script>
<style>

</style>
